import { AccountMovementsViewModel } from "../../accounting/models/accounting-movement.model";

export class InvestmentInCompaniesModel {

  uid: string;
  accountingModelsNumber: string;
  accountingModelsId: number;
  filesInvestmentUid: string;
  isImage: boolean;
  isPdf: boolean;
  investmentValue: number;
  investmentDate: Date;
  investmentDescription: string;
  numberOfUnitsOrSharesInvested: number;
  percentageOfProfitabilityOrInterest: number;
  termInMonths: number;
  netBookValue: number;
  lastBalanceSheetDate: number; // Can be null
  generatesReturns: boolean;
  paided: string;
  manualMovement: AccountMovementsViewModel;
  accountingModelsName?: string;
  paidAmount?: number;
  lastDepositDate?: Date | string | null;

  constructor() {
    this.investmentValue = 0;
  }

}

export class InvestmentInCompaniesDepositsModel {

  uid: string;
  investmentsInCompaniesId: string;
  paymentCardsUid: string;
  bankAccountsUid: string;
  amount: number;
  depositDate: Date;
  typePay: string;
  commissions: number;
  bankAccountInfo: string;
  efectivoId: string;
  partnersId: number;
  polizaCreditoId: string;
  total?: number;
  totalDeposit?: number;
  date?: string;
  concepto?: string;
  tableName?: string;
  conciliationId?: number | null;

  constructor() { }

}

export class InvestmentInCompaniesAccountModel {
  id: string;
  uid: string;
  number: string;
  name: string;
  type: string;
  accountGroup: string;
  accountTypeGroup: string;
}
